import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import { useAdminStore } from '@/stores'

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/LoginView.vue'),
    meta: { title: '登录', public: true },
  },
  {
    path: '/',
    name: 'Dashboard',
    component: () => import('@/views/DashboardView.vue'),
    meta: { title: '仪表盘', icon: '📊' },
  },
  {
    path: '/users',
    name: 'UserManage',
    component: () => import('@/views/UserManageView.vue'),
    meta: { title: '用户管理', icon: '👥' },
  },
  {
    path: '/apps',
    name: 'AppReview',
    component: () => import('@/views/AppReviewView.vue'),
    meta: { title: '应用审核', icon: '📦' },
  },
  {
    path: '/billing',
    name: 'BillingAdmin',
    component: () => import('@/views/BillingAdminView.vue'),
    meta: { title: '计费管理', icon: '💰' },
  },
  {
    path: '/channels',
    name: 'ChannelManage',
    component: () => import('@/views/ChannelManageView.vue'),
    meta: { title: '渠道管理', icon: '🔗' },
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to, _from, next) => {
  document.title = to.meta.title ? `${to.meta.title} - 阿旺运营后台` : '阿旺运营后台'

  const adminStore = useAdminStore()
  const isPublic = to.meta.public === true

  if (!isPublic && !adminStore.isLoggedIn) {
    next('/login')
    return
  }

  if (to.path === '/login' && adminStore.isLoggedIn) {
    next('/')
    return
  }

  next()
})

export default router
